import * as React from 'react';
import moment from 'moment';
import { MonthSelectionDropdownProps } from '../../components/month-selection/dropdown';
import { scrollToMonth } from '../../helpers/scroll-to-month';

const momentFormat = 'YYYY-MM';

const MonthSelectionDropdownView: React.StatelessComponent<MonthSelectionDropdownProps> = props => {
    function goToMonthChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const mmt = moment(evt.currentTarget.value, momentFormat);

        props.goToMonth(mmt);

        var focusDestinationMonth = setInterval(() => {
            if (scrollToMonth(mmt)) {
                clearInterval(focusDestinationMonth);
            }
        }, 500);
    }

    return (
        <div className="ace-cal-month-dropdown ace-cal-subnav-item">
            <label htmlFor="MonthDropdown" className="visually-hidden">{props.text.monthDropdownDescriptionText}</label>
            <select value={props.currentMonth.format(momentFormat)} onChange={goToMonthChange} id="MonthDropdown" className="h3-style">
                {
                    props.validMonths.map(month => <option key={month.format(momentFormat)} value={month.format(momentFormat)}>{month.format("MMMM YYYY")}</option>)
                }
            </select>
        </div>
    );
}

export default MonthSelectionDropdownView;